//React
//Components
import {
  AlphaNumericInput,
  Button,
  Card,
  Chart,
  DashboardHeader,
  DashboardScreen,
  Dropdown,
  EmailRegistrationModal,
  FlexBox,
  Input,
  Radio,
  RupeeAmount,
  Screen,
  TranslatedString,
  Image,
} from "components";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import {
  AllApplicationsApi,
  GetUserDetailsApi,
  registerClientApi,
  setGeneralDetails,
  useAllApplicationsApiDetails,
  useGeneralDetails,
  useGetUserDetailsApiDetails,
  useRegisterClientApiDetails,
} from "Slices";
//Utils
import { ChangeHistory, EventManager, EventNames, validateEmail } from "utils";
//Styles
import "./styles.scss";
//Assets
import ProfileIcon from "assets/icons/profile.svg";
import NotificationIcon from "assets/icons/notification.png";
import ApplicationBannerHand from "assets/Dashboard/banner1.png";
import JavaIcon from "assets/icons/java.png";
import AndroidIcon from "assets/icons/android.svg";
import AppleIcon from "assets/icons/apple.svg";
import RestApiIcon from "assets/icons/rest-api.svg";
import RightArrowImg from "assets/icons/down-arrow.png";
//Library
import cx from "classnames";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

const applications = [
  {
    name: "My First Project",
    type: "Android",
    applicationID: "xxxxxx444356",
    secretKey: "xxxxxxxxxxx444356",
  },
  {
    name: "My Second Project",
    type: "iOS",
    applicationID: "xxxxxx145231",
    secretKey: "xxxxxxxxxxx099312",
  },
  {
    name: "My Third Project",
    type: "Web",
    applicationID: "xxxxxx765434",
    secretKey: "xxxxxxxxxxx097891",
  },
];

const AllApplications = () => {
  //Dispatch
  const dispatch = useDispatch();
  const [graphType, setGraphType] = useState("Chart View");
  const [dataSelector, setDataSelector] = useState("Total");

  //Slices
  const userDetails = useGetUserDetailsApiDetails();
  const allApplications = useAllApplicationsApiDetails();

  useEffect(() => {
    setGeneralDetails({
      activeSideMenuOption: "Application",
    });
    if (userDetails?.data?.organizations?.[0].id) {
      getAllApplications(userDetails?.data);
    } else {
      dispatch(
        GetUserDetailsApi({
          callback: getAllApplications,
        })
      );
    }
  }, []);

  const getAllApplications = (userDetails?: any) => {
    dispatch(
      AllApplicationsApi({
        organizationId: localStorage.getItem("organisationID"),
      })
    );
  };

  const routeToApplicationDetails = (activeApplicationID) => {
    setGeneralDetails({
      activeApplicationID,
    });
    ChangeHistory("push", ROUTE_PATH.DASHBOARD.APPLICATION_DETAILS);
  };

  //Render UI
  const TopSection = <DashboardHeader title={"Application"} />;

  const BannerSection = (
    <Card className="clr-white w-100 animated fadeInUp delay-01s activity-banners mr-v-30">
      <FlexBox justifyBetween alignCenter className="fs-14">
        <p className="w-70">
          Setup a android, iOS or web application to use OTPless for
          authentication
        </p>
        <Button
          text={"+ Add Application"}
          onClick={() => {
            setGeneralDetails({
              activeSideMenuOption: "Application",
            });
            ChangeHistory("push", ROUTE_PATH.DASHBOARD.CREATE_APPLICATION);
          }}
        />
      </FlexBox>
    </Card>
  );

  const StepsSection = (
    <div className="steps-section">
      <p className="font-heavy fs-16 mr-b-30 animated fadeInUp delay-02s">
        Your Applications
      </p>
      <FlexBox
        flexColumn
        flexWrap
        justifyBetween
        alignCenter
        className="application-list"
      >
        {allApplications?.data?.length > 0 &&
          allApplications?.data?.map((item: any, index: number) => {
            return (
              <Card
                className={cx(
                  "animated fadeInUp delay-03s curs-point application clicking-animation w-100 mr-b-30"
                )}
                onClick={() => {
                  routeToApplicationDetails(item?.applicationId);
                  ChangeHistory(
                    "push",
                    ROUTE_PATH.DASHBOARD.APPLICATION_DETAILS
                  );
                }}
                key={`application-list-${index}`}
              >
                <FlexBox justifyAround alignCenter>
                  <FlexBox alignCenter className="w-50">
                    <Image
                      src={
                        item?.platform === "IOS"
                          ? AppleIcon
                          : item?.platform === "ANDROID"
                          ? AndroidIcon
                          : JavaIcon
                      }
                      className="platform-img"
                    />
                    <div className="word-break mr-t-10 mr-l-20">
                      <p className="fs-20 font-heavy">{item?.appName}</p>
                      <p className="fs-12 clr-disabled">
                        {item?.platform ?? "Android"}
                      </p>
                    </div>
                  </FlexBox>
                  <div className="w-20 env-status fs-14">
                    <p
                      className={
                        item.envs.UAT.status === "ACTIVE"
                          ? "active"
                          : "inactive"
                      }
                    >
                      Test Env
                    </p>
                    <p
                      className={
                        item.envs.PROD.status === "ACTIVE"
                          ? "active"
                          : "inactive"
                      }
                    >
                      Live Env
                    </p>
                    {(item.envs.UAT.status === "INACTIVE" ||
                      item.envs.PROD.status === "INACTIVE") && (
                      <div className="acknowledgement animated zoomIn fs-10 pd-10">
                        {item.envs.PROD.status === "INACTIVE"
                          ? item?.platform === "ANDROID" ||
                            item?.platform === "IOS"
                            ? "RedirectionURL and package name needs to be set to activate the app"
                            : "RedirectionURL and domain needs to be set to activate the app"
                          : "Redirection URL needs to be set to activate the App"}
                      </div>
                    )}
                  </div>
                  <div className="w-10 text-right">
                    <Image src={RightArrowImg} className="list-right-arrow" />
                  </div>
                </FlexBox>
              </Card>
            );
          })}
      </FlexBox>
    </div>
  );

  //Return UI
  return (
    <DashboardScreen
      className="application-screen"
      hasSideMenu
      hasHeader
      screenAnimationClass="no-animation"
    >
      {TopSection}
      {BannerSection}
      {StepsSection}
    </DashboardScreen>
  );
};

export default AllApplications;
